import useModal from '../../hooks/useModal';

const Modal = (): null | JSX.Element => {
  const { modal } = useModal();

  return modal;
};

export default Modal;
